import React from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import { Auth0Provider } from '@auth0/auth0-react';

import RequiredAuth from './RequiredAuth';
import Layout from './Layout';
import Project from './Project';
import Sample from './Sample';
import Profile from './Profile';
import LoginCallback from './LoginCallback'
import { IdentifiedSpeciesFiltersProvider } from './context/IdentifiedSpeciesFiltersContext';
import { ProjectProvider } from './context/ProjectContext';

function App() {
  const navigate = useNavigate();

  const onRedirectCallback = (appState) => {
    navigate(appState?.returnTo || window.location.pathname);
  }

  return (
    <div>
      <Auth0Provider
        domain={process.env.REACT_APP_KEYNOME_AUTH0_DOMAIN}
        clientId={process.env.REACT_APP_KEYNOME_AUTH0_CLIENT_ID}
        authorizationParams={{
          redirect_uri: `${window.location.origin}/callback`,
          scope: [
            'profile',
            'dzd.keynome.organizations.view',
            'dzd.keynome.projects.manage',
            'dzd.keynome.projects.view',
            'dzd.keynome.tests.manage',
            'dzd.keynome.runs.view',
            'dzd.keynome.runs.manage',
            'dzd.keynome.lib_seqs.view',
            'dzd.keynome.lib_seqs.manage',
            'dzd.keynome.concatenated_fastqgzs.view',
            'dzd.keynome.concatenated_fastqgzs.manage',
            'dzd.keynome.analysis_executions.view',
            'dzd.keynome.analyses.view',
            'dzd.keynome.tests.view',
            'dzd.keynome.identified_species.view',
            'dzd.keynome.amr_model_predictions.view',
            'dzd.keynome.imputations.view',
            'dzd.keynome.users.view',
            'dzd.keynome.users.manage',
            'dzd.keynome.resistance_genes.view',
            'dzd.keynome.api_keys.view',
            'dzd.keynome.api_keys.manage',
            'dzd.keynome.sample_types.view',
            'dzd.keynome.clonality_comparisons.view'
          ].join(" "),
          audience: "https://keynome-api"
        }}
        onRedirectCallback={onRedirectCallback}
      >
        <Routes>
          <Route path="/callback" element={<LoginCallback />} />
          <Route path="/" element={<RequiredAuth />}>
            <Route path="" element={<ProjectProvider><Layout /></ProjectProvider>}>
              <Route path="" element={<Project />} />
              <Route path="profile" element={<Profile />} />
              <Route path="projects/:projectId" element={<Project />} />
              <Route path="projects/:projectId/runs/:runId" element={<Project />} />
              <Route path="projects/:projectId/runs/:runId/samples/:sampleId" element={<IdentifiedSpeciesFiltersProvider><Sample /></IdentifiedSpeciesFiltersProvider>} />
            </Route>
          </Route>
        </Routes>
      </Auth0Provider>
    </div>
  );
}

export default App;
